import {
  AllbokService,
  AllbokTemplate,
  BookbitesService,
  BookbitesTemplate,
  ComicsplusService,
  ComicsplusTemplate,
  DigitalLibraryServiceCategory,
  DigitaltNasjonaltLanekortService,
  DigitaltNasjonaltLanekortTemplate,
  FilmoteketService,
  FilmoteketTemplate,
  FlippService,
  FlippTemplate,
  LibbyService,
  LibbyTemplate,
  NaxosService,
  NaxosTemplate,
  PressreaderService,
  PressreaderTemplate,
} from "@libry-content/types";
import { ResolvedDigitalLibraryService, ResolvedDigitalLibraryServiceSummary } from "@libry-content/common";

export type CategoryWithServices = [DigitalLibraryServiceCategory, ResolvedDigitalLibraryServiceSummary[]];

export const isLibraryAppCategory = (category: DigitalLibraryServiceCategory) => category === "library-app";

export const isBookbites = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<BookbitesTemplate, "_type"> & BookbitesService =>
  typeof item === "object" && item?.["_type"] === "bookbitesService";

export const isDigitaltNasjonaltLanekort = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<DigitaltNasjonaltLanekortTemplate, "_type"> & DigitaltNasjonaltLanekortService =>
  typeof item === "object" && item?.["_type"] === "digitaltNasjonaltLanekortService";

export const isFilmoteket = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<FilmoteketTemplate, "_type"> & FilmoteketService =>
  typeof item === "object" && item?.["_type"] === "filmoteketService";

export const isFlipp = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<FlippTemplate, "_type"> & FlippService =>
  typeof item === "object" && item?.["_type"] === "flippService";

export const isLibby = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<LibbyTemplate, "_type"> & LibbyService =>
  typeof item === "object" && item?.["_type"] === "libbyService";

export const isAllbok = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<AllbokTemplate, "_type"> & AllbokService =>
  typeof item === "object" && item?.["_type"] === "allbokService";

export const isNaxos = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<NaxosTemplate, "_type"> & NaxosService =>
  typeof item === "object" && item?.["_type"] === "naxosService";

export const isPressreader = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<PressreaderTemplate, "_type"> & PressreaderService =>
  typeof item === "object" && item?.["_type"] === "pressreaderService";

export const isComicsPlus = (
  item: ResolvedDigitalLibraryService | undefined
): item is Omit<ComicsplusTemplate, "_type"> & ComicsplusService =>
  typeof item === "object" && item?.["_type"] === "comicsplusService";

export const isAuthenticatedService = (
  item: object | undefined
): item is Pick<PressreaderTemplate, "authenticatedServiceUrl" | "authenticatedServiceLoginInfo"> =>
  typeof item === "object" && !!(item as any)?.["authenticatedServiceUrl"];
